import React from 'react';
import { useTranslation } from "react-i18next";
import Content from '../containers/Content';
import Title from '../components/Title';
import ServiceCard from '../components/services/ServiceCard';
import CommonButton from '../components/CommonButton';
import imageUrls from '../utils/imagePaths';
import ContactPersonCard from '../components/services/ContactPersonCard';
import contacts from '../assets/contacts/contacts.json';
import { Helmet } from 'react-helmet';

const ManufacturingService = () => {
    const { t } = useTranslation();
    const serviceCards = t("service_page.manufacturing.service_cards", {
        returnObjects: true 
    });
    return (
    <>
        <Helmet>
          <title>{t('service_page.manufacturing.meta_title')}</title> 
          <meta name="description" content={t('service_page.manufacturing.meta_description')} />
        </Helmet>
        <Content className="px-8 mx-auto md:w-full">
            <div className="flex flex-col my-auto gap-6">
                <Title title={t("service_page.manufacturing.header")} />
                <div className="flex flex-col lg:flex-row gap-6">
                    <div className="flex flex-col gap-2 text-base leading-relaxed font-medium lg:w-3/4 lg:border-b lg:border-px lg:border-white lg:pb-6">
                        <div>{t("service_page.manufacturing.subtext1")}</div>
                        <div>{t("service_page.manufacturing.subtext2")}</div>
                        <div>{t("service_page.manufacturing.subtext3")}</div>
                    </div>
                    <div className="flex flex-col lg:w-1/4 lg:gap-2">
                        <CommonButton to="/contact?subject=request" special className="w-full self-end max-w-[50%] md:max-w-[25%] lg:max-w-[75%] px-6 py-3 border-white hover:shadow-subtle-glow transition-transform transform hover:scale-105 lg:mt-2">
                            {t("service_page.manufacturing.call_to_action")}
                        </CommonButton>
                        <div className="hidden lg:block w-full self-end max-w-[50%] lg:max-w-[75%] lg:my-auto">
                            <ContactPersonCard className="" contact={contacts[3]} />
                        </div>
                    </div>
                    <div className="lg:hidden flex border-b border-px border-white pb-2"></div>
                </div>
                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 pt-2 mx-auto">
                    {serviceCards.map((service_card, index) => (
                        <ServiceCard key={index} service_card={service_card} />
                    ))}
                    <div className="flex flex-col justify-center h-full text-left sm:px-3 py-1.5">
                        <img src={imageUrls.installation} alt="Installation Logo" className="max-w-[160px] lg:max-w-[200px] xl:max-w-[280px]" />
                    </div>
                </div>
            </div>
        </Content>
    </>
    );
};

export default ManufacturingService;
